import React from "react";

class GeneralErrorBoundary extends React.Component {
    state = {
        hasError: false,
        error: null,
    };

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
        };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Unhandled React rendering error", error, errorInfo);

        // Send this to your error-monitoring service if applicable.
        // reportError(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <>
                    {this.props.message &&
                        <div>{this.props.message}</div>
                    }
                </>
            );
        }

        return this.props.children;
    }
}

export default GeneralErrorBoundary;
